import { notificationFireTime } from './notificationScope'
// Shared policy only: producers keep creating their own candidates.
export const MAX_LOCAL_PENDING_BUDGET = 60

// Time remains the primary ordering. At an identical timestamp, an explicit
// personal reminder wins over routine anchors/reminders.
const KIND_PRIORITY = { personal_event: 0, first_class: 1, tomorrow_preview: 2, next_class: 3, test_class: 4 }

export function selectLocalNotificationBudget(candidates, budget = MAX_LOCAL_PENDING_BUDGET) {
  return [...(candidates ?? [])]
    .sort((a, b) => {
      const time = notificationFireTime(a) - notificationFireTime(b)
      if (time) return time
      const kind = (KIND_PRIORITY[a.extra?.kind] ?? 99) - (KIND_PRIORITY[b.extra?.kind] ?? 99)
      if (kind) return kind
      return Number(a.id) - Number(b.id)
    })
    .slice(0, budget)
}
